module.exports = __webpack_public_path__ + "static/media/wizualizacja-94.16ac0640.png";